import { Selector } from '@ngrx/store';

import { createSimpleSelector, namedProjector } from './selector-utils';
import { BaseMetaState, MetaState, PaginationState } from './types';

export interface MetaAdapter<S extends MetaState> {
  markAsPending: (state: S) => S;
  markAsLoaded: (state: S) => S;
  setError: (state: S, error: any) => S;
}

export const getMetaAdapter = <T extends MetaState>() =>
  <MetaAdapter<T>>{
    markAsPending: state => ({
      ...state,
      pending: true,
      failed: false,
      error: null,
    }),
    markAsLoaded: state => ({
      ...state,
      pending: false,
      loaded: true,
      failed: false,
      error: null,
    }),
    setError: (state, error) => ({
      ...state,
      pending: false,
      loaded: true,
      failed: true,
      error,
    }),
  };

export const metaAdapter = getMetaAdapter();

export const metaInitState: BaseMetaState = {
  pending: false,
  loaded: false,
  failed: false,
  error: null,
};

export const paginationInitState: PaginationState = {
  page: null,
  limit: null,
  totalCount: null,
};

export const getMetaSelectors = (baseSelector: Selector<any, MetaState>, namespace: string) => ({
  isPending: createSimpleSelector(
    baseSelector,
    namedProjector(`${namespace}IsPending`, ({ pending }) => pending),
  ),
  isLoaded: createSimpleSelector(
    baseSelector,
    namedProjector(`${namespace}IsLoaded`, ({ loaded }) => loaded),
  ),
  error: createSimpleSelector(
    baseSelector,
    namedProjector(`${namespace}Error`, ({ error }) => error),
  ),
  isFailed: createSimpleSelector(
    baseSelector,
    namedProjector(`${namespace}IsFailed`, ({ failed }) => failed),
  ),
});
